module.exports = __webpack_public_path__ + "static/media/Avatars_Other-15.39e75f49.png";